import type { ColumnDef } from '@tanstack/react-table';
import { Checkbox } from '@/components/ui/checkbox';
import { CellAction } from './cell-action';
import { Link } from 'react-router-dom';

export const createColumns = (organisationId?: string): ColumnDef<any>[] => [
  {
    id: 'select',
    header: ({ table }) => (
      <Checkbox
        checked={table.getIsAllRowsSelected()}
        onCheckedChange={(value) => table.toggleAllRowsSelected(!!value)}
      />
    ),
    cell: ({ row }) => (
      <Checkbox
        checked={row.getIsSelected()}
        onCheckedChange={(value) => row.toggleSelected(!!value)}
      />
    ),
    enableSorting: false,
    enableHiding: false
  },
  {
    accessorKey: 'name',
    header: 'File Name',
    cell: ({ row }) => {
      const fileName = row?.original?.name;

      const link = row?.original?.url?.trim()
        ? row.original.url
        : row?.original?.file?.url?.trim()
          ? row.original.file.url
          : null;

      if (!link) {
        return <span className='italic text-muted-foreground'>No file</span>;
      }

      return (
        <Link to={link} target='_blank' className='text-blue-600 underline'>
          {fileName || 'View file'}
        </Link>
      );
    }
  },
  {
    accessorKey: 'description',
    header: 'Description'
  },
  {
    accessorKey: 'createdAt',
    header: 'Date Added',
    cell: ({ row }) => {
      const date = new Date(row.original.createdAt);
      return <span>{date.toLocaleDateString()}</span>;
    }
  },
  {
    id: 'actions',
    cell: ({ row }) => <CellAction data={row.original} organisationId={organisationId} />
  }
];
